import * as actionType from '../../action/menu/actionType';

const initialState = {
    banners: [],
    error: null,
    loading: false,
    categories: [],
    products: [],
    menuType: {},
};

const reducer = (state = initialState, action) => {
    // Normalization: redux-persist may rehydrate stale/partial state.
    // Ensure fields expected to be arrays/objects are always safe.
    const normalizedState = {
        ...initialState,
        ...state,
        banners: Array.isArray(state?.banners) ? state.banners : [],
        categories: Array.isArray(state?.categories) ? state.categories : [],
        products: Array.isArray(state?.products) ? state.products : [],
        menuType: state?.menuType && typeof state.menuType === "object" ? state.menuType : {},
    };

    switch (action.type) {
        case actionType.FETCH_BANNERS_REQUEST:
            return {
                ...normalizedState,
                loading: true,
                error: null,
            };
        case actionType.FETCH_BANNERS_SUCCESS:
            return {
                ...normalizedState,
                banners: Array.isArray(action.payload) ? action.payload : [],
                loading: false,
                error: null,
            };
        case actionType.FETCH_BANNERS_FAILURE:
            return {
                ...normalizedState,
                banners: [],
                loading: false,
                error: action.error,
            };
        case actionType.FETCH_CATEGORIES_REQUEST:
            return {
                ...normalizedState,
                loading: true,
                error: null,
            };
        case actionType.FETCH_CATEGORIES_SUCCESS:
            return {
                ...normalizedState,
                categories: Array.isArray(action.payload) ? action.payload : [],
                loading: false,
                error: null,
            };
        case actionType.FETCH_CATEGORIES_FAILURE:
            return {
                ...normalizedState,
                categories: [],
                loading: false,
                error: action.error,
            };
        case actionType.FETCH_PRODUCTS_REQUEST: 
            return {
                ...normalizedState,
                loading: true,
                error: null,
            };
        case actionType.FETCH_PRODUCTS_SUCCESS: 
            return {
                ...normalizedState,
                products: Array.isArray(action.payload) ? action.payload : [],
                loading: false,
                error: null,
            };
        case actionType.FETCH_PRODUCTS_FAILURE:
            return {
                ...normalizedState,
                products: [],
                loading: false,
                error: action.error,
            };
        case actionType.SET_MENU_TYPE:
                return {
                    ...normalizedState,
                    menuType:
                        action.payload && typeof action.payload === "object"
                            ? action.payload
                            : {},
                };
    
        default:
            return normalizedState;
    }
};

export default reducer;
